{
  "name": "younium-paywall",
  "version": "2025.10.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "build:sandbox": "ng build --configuration sandbox",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "build:elements": "ng build --output-hashing none"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.2.25",
    "@angular/cdk": "^21.2.14",
    "@angular/common": "^21.2.25",
    "@angular/compiler": "^21.2.25",
    "@angular/core": "^21.2.25",
    "@angular/elements": "^21.2.25",
    "@angular/forms": "^21.2.25",
    "@angular/material": "^21.2.14",
    "@angular/platform-browser": "^21.2.25",
    "@angular/platform-browser-dynamic": "^21.2.25",
    "@angular/router": "^21.2.25",
    "@microsoft/signalr": "^8.0.7",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular/build": "^21.2.27",
    "@angular/cli": "^21.2.27",
    "@angular/compiler-cli": "^21.2.25",
    "@vitest/browser-playwright": "^4.1.12",
    "concat": "^1.0.3",
    "fs-extra": "^11.3.0",
    "playwright": "^1.64.1",
    "typescript": "~5.9.3",
    "vitest": "^4.1.12"
  },
  "overrides": {
    "undici@7": "^7.30.1"
  }
}
